import React from 'react'
import { observer } from 'mobx-react-lite'
import usePathwayAlignmentSubmission from './hooks/usePathwayAlignmentSubmission'
import s from './styles/PathwayAlignmentSubmission.module.scss'
import sharedStyles from '../shared/submissionStyles.module.scss'

const PathwayAlignmentSubmission = observer(({ assignment, student }) => {
	const { responseText, hasResponse } = usePathwayAlignmentSubmission({
		assignment,
		student,
	})

	return (
		<div className={s.container}>
			<div className={sharedStyles.submission}>
				<div className={sharedStyles.submission__inner}>
					<span className={sharedStyles.title}>SUBMISSION</span>
					<div className={sharedStyles.textArea}>
						{hasResponse ? (
							<p className={sharedStyles.textContent}>{responseText}</p>
						) : (
							<div className={sharedStyles.empty}>
								No response submitted yet
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	)
})

PathwayAlignmentSubmission.displayName = 'PathwayAlignmentSubmission'

export default PathwayAlignmentSubmission
